import { Directive, EventEmitter, Output, HostListener } from "@angular/core";

@Directive({
  selector: "[clickElseWhere]",
})
export class ClickElseWhereDirective {
  constructor() {}
  @Output() onClickElseWhere: EventEmitter<boolean> = new EventEmitter();
  //Added this directive for push menu outside click
  @HostListener("document:click", ["$event.target"]) onClickOutside(
    targetElement
  ) {
    if (targetElement?.id == "vm-overlay") {
      this.onClickElseWhere.emit(false);
    }
  }
}
